import * as React from 'react';
import ReactDom from 'react-dom';
import {set, merge, omit} from 'lodash';

import {useWithDataSource} from '@forms/Utils/Hooks';
import {send} from '@forms/Utils';
import Client from './Client';
import DEFAULT_PROPS from './Client/defaultProps';
import DEFAULT_DEV_PROPS from './Client/defaultProps_DEV';
import {GroupedTripsCollection, GroupToursRFQFormData} from './Client/definitions';

const hashToValues = () => {
	try {
		const hash = window.location.hash.substr(1) || '';

		if (!hash) {
			return {};
		}

		const [destinationValues, ...trips] = decodeURIComponent(escape(window.atob(hash))).split(',trip=');
		const destinations = destinationValues.split('=')[1].split(',');

		const groupedTrips: GroupedTripsCollection[] = destinations.map((name: string) => ({
			name,
			trips
		}));

		return set({}, 'quoteRequest.groupedTrips', groupedTrips);
	} catch(e) {}

	return {};
}

// Props, injected by dataset.
type GroupToursRFQForm = {
	component: string;
	csrfToken: string;
	labelUri: string;
	nodeAggregateIdentifier: string;
	redirectUri: string;
	rfqUri: string;
	tripUri: string;
	captchaIsActive: string;
	captchaSitekey: string;
}

export default ($el: HTMLElement) => {
	const $node = $el.querySelector('[data-select="groupToursRfqForm"]');

	if (!$node) {
		return null;
	}

	// Get injected config by dataset.
	const CONFIG = {...$el.dataset} as GroupToursRFQForm;
	const $disclaimer = $el.querySelector('[data-select="disclaimer"]') as HTMLElement;

	// Get default + injected props
	const defaultValues = merge({},
		DEFAULT_PROPS,
		window.location.search.includes('sitegeist=developer') && DEFAULT_DEV_PROPS,
		hashToValues()
	);

	const thanks = () => window.location.href = CONFIG.redirectUri;

	// Form API
	const submit = (data: GroupToursRFQFormData) => {
		send({
			uri: CONFIG.rfqUri,
			csrfToken: CONFIG.csrfToken,
			node: CONFIG.nodeAggregateIdentifier,
			data: {
				...omit(data, ['hidden']),
			},
			onSuccess: thanks,
			onFail: () => {}
		})
	}

	const withLabel = () => useWithDataSource({
		uri: CONFIG.labelUri
	});


	const withTrips = () => useWithDataSource({
		uri: CONFIG.tripUri
	});

	ReactDom.render(
		<Client {...{submit, withLabel, withTrips, $disclaimer, defaultValues}}
			captchaIsActive={CONFIG.captchaIsActive === "1"}
			captchaSitekey={CONFIG.captchaSitekey}
		/>,
		$node
	);
}
